import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  class: "filter-container",
  ref: "filterContainer"
}
const _hoisted_3 = { class: "action-list" }

import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, ref } from 'vue'
import { DelayStatus } from '@/enums/order'
import { getDelayOrderListApi, updateDelayOrderStatusApi } from '@/apis/order'


export default /*@__PURE__*/_defineComponent({
  __name: 'DelayList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()

const filters = reactive({
    order_no:   '',     // 订单号
    status:     0,      // 审核状态
    page_size:  10,     // 每页条数
    page:       1,      // 当前页码
})
const tableData = ref([]) // 表单数据
const total = ref(0) // 总条数
const getList = async () => {
    const { code, data, msg } = await getDelayOrderListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}
getList()

// 审核：1-通过，3-驳回
let formData:any = {}
const onCheck = async (type) => {
    let confirm = false
    if (type == 1) {
        confirm = await proxy.$confirm('确定审核通过吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
    } else if (type == 3) {
        if (!formData.reject_reson) {
            return proxy.$message({ type: 'error', message: '请输入驳回原因' })
        } else {
            confirm = await proxy.$confirm('确定要驳回吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
        }
    }

    if (confirm) {
        const { code, data, msg } = await updateDelayOrderStatusApi({ ...formData, type }) as any
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        proxy.$message({ type: 'success', message: '保存成功' })
        dialogBeforeClose()
        getList()
    }
}

const dialogVisible = ref(false) // 驳回弹框弹框
const dialogBeforeClose = () => {
    dialogVisible.value = false
    formData.reject_reson = ''
}

const handleSizeChange = (val) => {
    filters.page_size = val
    getList();
}
const handleCurrentChange = (val) => {
    filters.page = val
    getList();
}
const search = () => {
    filters.page = 1;
    getList();
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.order_no,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.order_no) = $event)),
        placeholder: "订单号"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.status) = $event)),
        placeholder: "审核状态"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: _unref(DelayStatus)[0],
            value: 0
          }, null, 8, ["label"]),
          _createVNode(_component_el_option, {
            label: _unref(DelayStatus)[1],
            value: 1
          }, null, 8, ["label"]),
          _createVNode(_component_el_option, {
            label: _unref(DelayStatus)[3],
            value: 3
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      })
    ], 512),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { label: "订单信息" }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("p", null, "订单号：" + _toDisplayString(row.order_no), 1),
            _createElementVNode("p", null, "品牌：" + _toDisplayString(row.brand_name), 1),
            _createElementVNode("p", null, "商品：" + _toDisplayString(row.product_name), 1),
            _createElementVNode("p", null, "支付时间：" + _toDisplayString(row.paid_at), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_name",
          label: "用户信息"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("p", null, "用户：" + _toDisplayString(row.user_name), 1),
            _createElementVNode("p", null, "来源渠道：" + _toDisplayString(row.channel_no), 1),
            _createElementVNode("p", null, "签收地址：" + _toDisplayString(row.addr), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "物流信息",
          width: "190"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("p", null, "物流公司：" + _toDisplayString(row.express_cp), 1),
            _createElementVNode("p", null, "物流单号：" + _toDisplayString(row.express_no), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "延迟发货信息" }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("p", null, "延迟发货时间：" + _toDisplayString(row.delay_delivery_time), 1),
            _createElementVNode("p", null, "延迟发货原因：" + _toDisplayString(row.delay_reson), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "审核状态",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("p", null, _toDisplayString(_unref(DelayStatus)[row.status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_unref(router).push(`/order/edit?id=${row.order_id}`))
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (row.status == 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_button, {
                      type: "success",
                      size: "small",
                      class: "mt5",
                      onClick: ($event: any) => {_isRef(formData) //@ts-ignore
 ? formData.value = row : formData = row; onCheck(1)}
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("通过")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "warning",
                      size: "small",
                      class: "mt5",
                      onClick: ($event: any) => {_isRef(formData) //@ts-ignore
 ? formData.value = row : formData = row; dialogVisible.value = true}
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("驳回")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      onSizeChange: handleSizeChange,
      onCurrentChange: handleCurrentChange,
      currentPage: filters.page,
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((filters.page) = $event)),
      "page-size": filters.page_size,
      layout: "total, prev, pager, next, jumper",
      total: total.value
    }, null, 8, ["currentPage", "page-size", "total"]),
    _createVNode(_component_el_dialog, {
      title: "驳回",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      "before-close": dialogBeforeClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeClose }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (onCheck(3)))
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "驳回原因",
              required: "",
              style: {"width":"450px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 5,
                  maxlength: "150",
                  "show-word-limit": "",
                  modelValue: _unref(formData).reject_reson,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).reject_reson) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})